// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__z5sCE","modal":"Modal_modal__j+e4t","Modal_slide-down__oEfui":"Modal_Modal_slide-down__oEfui__frH0n","slide-down":"Modal_slide-down__H7UtF"};